import React from 'react'

const HeadIcon =(props)=>{
  return(
  <><h3 className="title">{props.title}</h3></>
  )
}

export default HeadIcon